module.exports = __webpack_public_path__ + "8504d47178a28b71f3d1717dee4f7e5e.pdf";